import { buildApiUrl } from "../utils/apiConfig";
import { jsonGet, jsonSend } from "../utils/http";

export type PolarisHubItemKind = "VIDEO" | "RESOURCE";

export const POLARIS_HUB_AUDIENCE_ROLES = [
    "ADMINISTRATOR",
    "STAFF",
    "COACH",
    "ATHLETE",
    "GUARDIAN",
] as const;

export type PolarisHubAudienceRole = (typeof POLARIS_HUB_AUDIENCE_ROLES)[number];

export type PolarisHubItem = {
    id: number;
    kind: PolarisHubItemKind;
    title: string;
    description: string | null;
    url: string;
    visibleToRoles: PolarisHubAudienceRole[];
    createdAt: string;
    updatedAt: string;
};

export type PolarisHubItemPayload = {
    kind?: PolarisHubItemKind;
    title: string;
    description?: string | null;
    url: string;
    visibleToRoles: PolarisHubAudienceRole[];
};

export function fetchPolarisHubItems(kind?: PolarisHubItemKind) {
    const params = new URLSearchParams();
    if (kind) {
        params.set("kind", kind);
    }
    const query = params.toString();
    return jsonGet<PolarisHubItem[]>(
        `${buildApiUrl("api/polaris/hub-items")}${query ? `?${query}` : ""}`
    );
}

export function fetchVisiblePolarisHubItems(kind: PolarisHubItemKind) {
    const params = new URLSearchParams({ kind });
    return jsonGet<PolarisHubItem[]>(`${buildApiUrl("api/hub-items")}?${params.toString()}`);
}

export function createPolarisHubItem(payload: PolarisHubItemPayload & { kind: PolarisHubItemKind }) {
    return jsonSend<PolarisHubItem>(buildApiUrl("api/polaris/hub-items"), "POST", payload);
}

export function updatePolarisHubItem(id: number, payload: PolarisHubItemPayload) {
    return jsonSend<PolarisHubItem>(buildApiUrl(`api/polaris/hub-items/${id}`), "PATCH", payload);
}

export function deletePolarisHubItem(id: number) {
    return jsonSend<void>(buildApiUrl(`api/polaris/hub-items/${id}`), "DELETE");
}
